import { useState } from "react";
import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export function SaveButton({ race, className = "", onChange, variant = "floating" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [saved, setSaved] = useState(!!race.is_saved);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (!user) { toast("Create an account to save races"); nav("/login"); return; }
    if (busy) return;
    setBusy(true);
    const next = !saved;
    setSaved(next);
    try {
      if (next) await api.post(`/saved/${race.id}`);
      else await api.delete(`/saved/${race.id}`);
      onChange?.(next);
      toast.success(next ? "Race saved" : "Removed from saved");
    } catch {
      setSaved(!next);
      toast.error("Could not update saved races");
    } finally {
      setBusy(false);
    }
  };

  if (variant === "button") {
    return (
      <button onClick={toggle} data-testid="race-save-button"
        className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border font-semibold text-sm transition-colors ${
          saved ? "bg-red-50 border-red-200 text-red-500" : "border-slate-300 text-slate-700 hover:border-slate-400"} ${className}`}>
        <Heart size={18} fill={saved ? "currentColor" : "none"} />{saved ? "Saved" : "Save"}
      </button>
    );
  }

  return (
    <button onClick={toggle} data-testid="race-save-button"
      className={`p-2 bg-white/90 hover:bg-white rounded-full shadow-md backdrop-blur-sm transition-all ${saved ? "text-red-500" : "text-slate-700 hover:text-red-500"} ${className}`}>
      <Heart size={18} fill={saved ? "currentColor" : "none"} />
    </button>
  );
}
